import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-[1040px]" }
const _hoisted_2 = { class: "flex items-center justify-between gap-6" }
const _hoisted_3 = {
  key: 0,
  class: "border-t border-gray-100 pt-5"
}
const _hoisted_4 = {
  key: 0,
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_5 = { class: "flex justify-end" }
const _hoisted_6 = { class: "flex justify-end" }
const _hoisted_7 = {
  key: 1,
  class: "rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm"
}

import { XCircleIcon } from '@heroicons/vue/24/outline'
import { computed, inject, onMounted, ref } from 'vue'

import EmptyState from '@/components/neue/EmptyState'
import FormElement from '@/components/neue/FormElement'
import FormSection from '@/components/neue/FormSection'
import InputArea from '@/components/neue/InputArea'
import InputField from '@/components/neue/InputField'
import NeueButton from '@/components/neue/NeueButton'
import NeueLoading from '@/components/neue/NeueLoading'
import NeueTablist from '@/components/neue/NeueTablist'
import NeueToggle from '@/components/neue/NeueToggle'
import SelectInput from '@/components/neue/SelectInput'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import TablistGrid from '@/components/neue/TablistGrid'
import TablistHeader from '@/components/neue/TablistHeader'
import TablistRow from '@/components/neue/TablistRow'
import TheModal from '@/components/TheModal.vue'
import api from '@/store/api'
import { mapRelationship, mapRelationships } from '@/store/mappers'


export default {
  __name: 'StoreTipping',
  props: ['id'],
  setup(__props) {

const bus = inject('bus')
const loading = ref(true)
const modal = ref({ open: false, type: 'PercentageTipAmount', value: null })
const props = __props

const cols = [{ width: 'minmax(180px, 2fr)' }, { width: 'minmax(120px, 1fr)' }, { width: '100px' }]
const store = computed(() => mapRelationship({ type: 'store', id: props.id }))
const allow = ref(false)
const tips = computed(() => mapRelationships(store.value?.relationships.tip_amounts.data))
const text = ref('')

onMounted(async () => {
  await api.call('GET', `stores/${props.id}?included=tip_amounts`)
  loading.value = false
  allow.value = store.value.attributes.allow_tipping
  text.value = store.value.attributes.tip_modal_text
})

const setAllow = value => {
  api.call('PUT', `stores/${props.id}?included=none`, {
    store: {
      allow_tipping: value
    }
  })
}

const openModal = () => {
  modal.value = {
    open: true,
    type: 'PercentageTipAmount',
    value: null
  }
}

const saveModal = () => {
  if (!modal.value.value) return
  let tipAmount
  if (modal.value.type === 'PercentageTipAmount') {
    tipAmount = {
      tip_percentage: modal.value.value
    }
  } else {
    tipAmount = {
      tip_amount_cents: modal.value.value * 100
    }
  }

  api.call('PUT', `stores/${props.id}?included=tip_amounts`, {
    store: {
      tip_amounts_attributes: [
        {
          type: modal.value.type,
          ...tipAmount
        }
      ]
    }
  })
  modal.value.open = false
}

const deleteTip = tip => {
  if (!confirm('Delete this tip option?')) return
  api.call('PUT', `stores/${props.id}?included=none`, {
    store: {
      tip_amounts_attributes: [
        {
          id: tip.id,
          _destroy: true
        }
      ]
    }
  })
}

const dirty = () => bus.emit('dirty/store', { from: 'tipping' })

bus.on('save/store', () => {
  api.call('PUT', `stores/${props.id}?included=none`, {
    store: {
      tip_modal_text: text.value
    }
  })
})

bus.on('discard/store', () => {
  text.value = store.value.attributes.tip_modal_text
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(NeueLoading), { loading: loading.value }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(SettingsSection, {
            title: "Tipping",
            description: "Offer optional tipping at checkout, with the amounts you suggest."
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "min-w-0" }, [
                  _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Offer tipping"),
                  _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, "Off means no tip step appears at checkout.")
                ], -1)),
                _createVNode(_unref(NeueToggle), {
                  modelValue: allow.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((allow).value = $event)),
                  onChange: setAllow
                }, null, 8, ["modelValue"])
              ]),
              (allow.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_unref(InputArea), {
                      modelValue: text.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((text).value = $event)),
                      name: "Tip and payment description",
                      placeholder: "Optional message above the tip and payment box.",
                      onInput: dirty
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (allow.value)
            ? (_openBlock(), _createBlock(SettingsSection, {
                key: 0,
                title: "Suggested amounts",
                description: "The tips a customer can pick with one tap. They can always enter their own instead.",
                plain: ""
              }, {
                default: _withCtx(() => [
                  (tips.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_unref(NeueTablist), null, {
                          head: _withCtx(() => [
                            _createVNode(_unref(TablistHeader), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(TablistGrid), {
                                  columns: cols,
                                  header: "",
                                  class: "items-center"
                                }, {
                                  default: _withCtx(() => [
                                    _cache[9] || (_cache[9] = _createElementVNode("div", null, "Type", -1)),
                                    _cache[10] || (_cache[10] = _createElementVNode("div", null, "Amount", -1)),
                                    _createElementVNode("div", _hoisted_5, [
                                      _createVNode(_unref(NeueButton), {
                                        type: "secondary",
                                        onClick: _withModifiers(openModal, ["prevent"])
                                      }, {
                                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                          _createTextVNode("+ Tip", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tips.value, (tip) => {
                              return (_openBlock(), _createBlock(_unref(TablistRow), {
                                key: tip.id
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(TablistGrid), {
                                    columns: cols,
                                    class: "items-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", null, _toDisplayString(tip.attributes.type === 'PercentageTipAmount' ? 'Percentage amount' : 'Dollar amount'), 1),
                                      _createElementVNode("div", null, _toDisplayString(tip.attributes.type === 'PercentageTipAmount'
                      ? tip.attributes.tip_percentage + '%'
                      : tip.attributes.default_tip_amount.format), 1),
                                      _createElementVNode("div", _hoisted_6, [
                                        _createVNode(_unref(XCircleIcon), {
                                          class: "cursor-pointer h-6 w-6 hover:text-black",
                                          onClick: $event => (deleteTip(tip))
                                        }, null, 8, ["onClick"])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_unref(EmptyState), { plural: "tips" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NeueButton), {
                              type: "secondary",
                              onClick: _withModifiers(openModal, ["prevent"])
                            }, {
                              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                _createTextVNode("+ Tip", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(TheModal, {
      "is-open": modal.value.open,
      "modal-title": "Tip amount",
      onCloseModal: _cache[6] || (_cache[6] = $event => (modal.value.open = false))
    }, {
      main: _withCtx(() => [
        _createVNode(_unref(FormSection), null, {
          default: _withCtx(() => [
            _createVNode(_unref(FormElement), { size: "3" }, {
              default: _withCtx(() => [
                _createVNode(_unref(SelectInput), {
                  modelValue: modal.value.type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((modal.value.type) = $event)),
                  name: "Type",
                  options: [
              { name: 'Percentage amount', value: 'PercentageTipAmount' },
              { name: 'Dollar amount', value: 'CustomTipAmount' }
            ]
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (modal.value.type === 'PercentageTipAmount')
              ? (_openBlock(), _createBlock(_unref(FormElement), {
                  key: 0,
                  size: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(InputField), {
                      modelValue: modal.value.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((modal.value.value) = $event)),
                      name: "Percentage amount",
                      suffix: "%",
                      placeholder: "15"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (modal.value.type === 'CustomTipAmount')
              ? (_openBlock(), _createBlock(_unref(FormElement), {
                  key: 1,
                  size: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(InputField), {
                      modelValue: modal.value.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((modal.value.value) = $event)),
                      name: "Dollar amount",
                      prefix: "$",
                      placeholder: "5.00"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(NeueButton), {
          type: "secondary",
          onClick: _cache[5] || (_cache[5] = $event => (modal.value.open = false))
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(NeueButton), {
          type: modal.value.value ? 'primary' : 'inactive',
          onClick: saveModal
        }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
            _createTextVNode("Save", -1)
          ]))]),
          _: 1
        }, 8, ["type"])
      ]),
      _: 1
    }, 8, ["is-open"])
  ], 64))
}
}

}